'use strict';

module.exports = require('./_source/linked-list.js');



//////////////////
// WEBPACK FOOTER
// ./~/linked-list/index.js
// module id = 504
// module chunks = 0